"use strict";

require("custom-event-polyfill");
require("./ElementPolyfill");


//////////////////
// WEBPACK FOOTER
// ./~/formiojs/polyfills/index.js
// module id = 3109
// module chunks = 0